import { useEffect, useMemo, useState } from "react";

export const getNextSession = () => {
  const now = new Date();
  const d = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 11, 0, 0)
  );
  while (d.getUTCDay() !== 4 || d <= now) d.setUTCDate(d.getUTCDate() + 1);
  return d;
};

export const sessionLabel = (d) =>
  d
    .toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
      timeZone: "UTC",
    })
    .toUpperCase() + " · 11:00 AM UTC";

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = () => {
  const target = useMemo(getNextSession, []);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, target.getTime() - now);
  const units = [
    pad(Math.floor(diff / 86400000)),
    pad(Math.floor(diff / 3600000) % 24),
    pad(Math.floor(diff / 60000) % 60),
    pad(Math.floor(diff / 1000) % 60),
  ];

  return (
    <div
      data-testid="countdown-timer"
      className="bg-[#E14B4B] rounded-xl text-center py-4 px-5 shadow-md shadow-red-200"
    >
      <p className="font-display font-bold text-white text-sm tracking-wide">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-white animate-pulse-dot mr-1.5 align-middle" />
        LIVE SOON! JOIN BELOW
      </p>
      <p className="font-display font-extrabold text-white text-3xl sm:text-4xl mt-1.5 tabular-nums tracking-wide">
        {units[0]}
        <span className="text-white/60 mx-0.5">:</span>
        {units[1]}
        <span className="text-white/60 mx-0.5">:</span>
        {units[2]}
        <span className="text-white/60 mx-0.5">:</span>
        {units[3]}
      </p>
      <div className="flex justify-center gap-5 sm:gap-8 mt-0.5">
        {["DAYS", "HOURS", "MINUTES", "SECONDS"].map((l) => (
          <span key={l} className="text-white/90 text-[9px] font-semibold tracking-[0.15em]">
            {l}
          </span>
        ))}
      </div>
      <p data-testid="session-date" className="text-white/90 text-[11px] font-semibold mt-2 tracking-wide">
        {sessionLabel(target)}
      </p>
    </div>
  );
};
